import React from 'react'

const PrimaryLoanIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <circle
                cx="12"
                cy="12"
                r="9"
                stroke="#E07839"
                strokeWidth="2"
            />
            <path
                d="M12 6V12L16 14"
                stroke="#E07839"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9 9H15"
                stroke="#E07839"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                d="M9 15H15"
                stroke="#E07839"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                d="M12 9V15"
                stroke="#E07839"
                strokeWidth="2"
                strokeLinecap="round"
            />
        </svg>
    )
}

export default PrimaryLoanIcon

